import React from "react";

const OnboardingStep5 = ({ activeItems, toggleSubMenu, handleNext }) => {
  const isActive = (item) => activeItems.includes(item);

  const handleToggle = (item) => {
    const groupItems = [
      "activity-0",
      "activity-1",
      "activity-2",
      "activity-3",
      "activity-4",
    ];
    groupItems.forEach((activeItem) => {
      if (isActive(activeItem)) {
        toggleSubMenu(activeItem);
      }
    });
    toggleSubMenu(item);
  };

  const groupItems = [
    "activity-0",
    "activity-1",
    "activity-2",
    "activity-3",
    "activity-4",
  ];

  const activityLabels = [
    "Sedentary",
    "Lightly active",
    "Moderate",
    "Quite active",
    "Very active",
  ];

  const handleNextWithStorage = () => {
    const activity = groupItems.findIndex((activityLevel) =>
      isActive(activityLevel)
    );
    if (activity !== -1) {
      localStorage.setItem("activity_level", activity + 1);
    }
    handleNext();
  };

  const isItemActive = groupItems.some(isActive);

  return (
    <div className="modal-container animated-onboarding onboarding-step5 fadeIn">
      <div className="modal-container-title fade1 heading">
        How active were you before your knee problem?
      </div>

      <ul className="selection selection-flex-col selection-ico fade3 with-box-icon nowrap mt-50">
        {groupItems.map((activityLevel, index) => (
          <li
            key={activityLevel}
            className={`with-icon ${isActive(activityLevel) ? "active" : ""}`}
            onClick={() => handleToggle(activityLevel)}
          >
            <p className="icon-index">{index + 1}</p>
            <div className={`div-ico ico ico-activity-${index}`}></div>
            <span className={`icon icon-${index}`}></span>
            <p className="icon-text">{activityLabels[index]}</p>
          </li>
        ))}
      </ul>
      {isItemActive && (
        <>
          <div className="nav-container fade-fast">
            <button
              className="btn-next next-btn"
              onClick={handleNextWithStorage}
            >
              Next
            </button>
          </div>
          <div className="dot-container fade-fast">
            <div className="dot-unchecked"></div>
            <div className="dot-unchecked"></div>
            <div className="dot-unchecked"></div>
            <div className="dot-unchecked"></div>
            <div className="dot-checked"></div>
            <div className="dot-unchecked"></div>
          </div>
        </>
      )}
    </div>
  );
};

export default OnboardingStep5;
